// extracted by mini-css-extract-plugin
module.exports = {"confirm":"code-confirm_confirm__ZRYI3","code":"code-confirm_code__9uiv8","digitInput":"code-confirm_digitInput__3J_GR"};